// extracted by mini-css-extract-plugin
module.exports = {"text":"style_text__Zm9JO","label":"style_label__y4A7D","error":"style_error__z8e+h","select":"style_select__WtYmi","inputDisabled":"style_inputDisabled__0udcU"};